import { jsx as _jsx } from "react/jsx-runtime";
import './TS_SimpleDialog.scss';
import { TS_Dialog } from './TS_Dialog.js';
import { ModuleFE_Dialog } from '../../component-modules/ModuleFE_Dialog.js';
export class TS_SimpleDialog extends TS_Dialog {
    static defaultProps = {
        dialogId: 'order-graph',
        className: 'order-graph'
    };
    constructor(p) {
        super(p);
    }
    static show(props) {
        ModuleFE_Dialog.show({ content: _jsx(TS_SimpleDialog, { ...props }) });
    }
    renderHeader = () => this.props.title;
    renderBody = () => this.props.body;
    buttons = () => {
        return {
            right: [{
                    content: this.props.actionButtonProps.label,
                    associatedKeys: ['enter'],
                    onClick: async () => {
                        await this.props.actionButtonProps.action();
                        this.closeDialog();
                    },
                }],
            left: [{
                    content: this.props.negativeButtonProps.label,
                    associatedKeys: ['escape'],
                    onClick: async () => {
                        await this.props.negativeButtonProps.action?.();
                        this.closeDialog();
                    },
                }]
        };
    };
}
//# sourceMappingURL=TS_SimpleDialogue.js.map